import { get, post, patch, del } from './client.js';

const base = (orgId) => `/orgs/${orgId}/ai`;

export const orgAiApi = {
  stats: (orgId) => get(`${base(orgId)}/stats`),
  models: (orgId) => get(`${base(orgId)}/models`),
  usage: (orgId) => get(`${base(orgId)}/usage`),

  // Agents
  listAgents: (orgId) => get(`${base(orgId)}/agents`),
  getAgent: (orgId, agentId) => get(`${base(orgId)}/agents/${agentId}`),
  createAgent: (orgId, data) => post(`${base(orgId)}/agents`, data),
  updateAgent: (orgId, agentId, data) => patch(`${base(orgId)}/agents/${agentId}`, data),
  deployAgent: (orgId, agentId) => post(`${base(orgId)}/agents/${agentId}/deploy`),
  deleteAgent: (orgId, agentId) => del(`${base(orgId)}/agents/${agentId}`),

  // Knowledge Bases
  listKBs: (orgId) => get(`${base(orgId)}/knowledge-bases`),
  createKB: (orgId, data) => post(`${base(orgId)}/knowledge-bases`, data),
  deleteKB: (orgId, kbId) => del(`${base(orgId)}/knowledge-bases/${kbId}`),

  // Prompts
  listPrompts: (orgId) => get(`${base(orgId)}/prompts`),
  createPrompt: (orgId, data) => post(`${base(orgId)}/prompts`, data),
  updatePrompt: (orgId, promptId, data) => patch(`${base(orgId)}/prompts/${promptId}`, data),
  deletePrompt: (orgId, promptId) => del(`${base(orgId)}/prompts/${promptId}`),

  // API Keys
  listKeys:  (orgId)        => get(`${base(orgId)}/keys`),
  addKey:    (orgId, data)  => post(`${base(orgId)}/keys`, data),
  deleteKey: (orgId, keyId) => del(`${base(orgId)}/keys/${keyId}`),
};
